import { mainAdminSplitApi } from 'redux/store/mainSplitApi'
import { type ApplicationInfo, type ToleranceConfig } from 'types'

const appInfoApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppInfo: builder.query<ApplicationInfo, void>({
      query: () => '/application-metadata'
    }),
    getToleranceConfig: builder.query<ToleranceConfig, void>({
      query: () => '/application-metadata/tolerance'
    })
  })
})

export const { useGetAppInfoQuery, useGetToleranceConfigQuery } = appInfoApi
